import { getCategoryLevel } from '../restructure/analytics/amplitude/buildProductListObject'

interface Props {
  listType: string
  listName: string
  productsCount: number
  facets?: Array<{ key: string; value: string }>
  productPosition: number
  pageNumber?: number
  sortOrder?: string
  base?: string
}

export function buildProductSelectedObject({
  listName,
  listType,
  productsCount,
  facets,
  productPosition,
  pageNumber,
  sortOrder,
  base,
}: Props) {
  const filters = facets
    ? facets.map((facet) => ({
        'filter type':
          facet?.key === 'sellername' ? 'desconto pix' : facet?.key,
        'filter value':
          facet?.value === 'iguasport-ltda' ? 'true' : facet?.value,
      }))
    : []

  return {
    'product list type': listType,
    'product list name': listName,
    'product list level': getCategoryLevel(base),
    'filter details': filters?.length === 0 ? null : filters,
    'number filters applied': filters.length,
    'sort order': sortOrder ?? null,
    'product list page number': pageNumber ?? 1,
    'number of products': productsCount,
    'product position': productPosition,
  }
}
